<template>
  <div class="progress-line">
    <div class="progress-line__inner" :style="{width: value >= 100 ? 100 +'%' : value + '%'}"></div>
  </div>
</template>

<script>
export default {
  name: "ProgressLine",
  data() {
    return {};
  },
  props: {
    value: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped lang="less">
.progress-line {
  width: 100%;
  height: 0.38rem;
  border-radius: 0.38rem;
  background-color: #404040;

  &__inner {
    height: 100%;
    border-radius: 0.38rem;
    overflow: hidden;
    // background-image: linear-gradient(90deg, #456dd0, #0e7aef);
    .skeleton-color();
    transition: width 0.3s linear;
  }

  .skeleton-color() {
    background: @progress-gradient;
    animation: skeleton-loading 1.3s ease infinite;
    background-size: 400% 100%;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }
}
</style>